import AlertContainer from './AlertContainer'
import { useTranslation } from 'react-i18next'

const SyncInProgressAlert = () => {
  const { t } = useTranslation('dataSync')
  return <AlertContainer type="alert" alertText={t('inProgress')} alertColor="orange" height="small" />
}

export default SyncInProgressAlert
